<template>
    <div>
        <div class="items">
            <div class="item card-white""> <!-- :class="{ 'margin-200-top': status.complete } -->

                <div class="card margin-card" v-if="!status.complete">
                  <eyebrow-icon v-if="true" v-bind:eyebrowicon="{'icon':'star-outline', 'color':'black'}" v-bind:align="'center'"></eyebrow-icon>
                  <h4>Share your feedback on {{ this.acf.model }}</h4>
                </div>

                <form id="ContactForm" ref="contact_form" class="contact-form" action="javascript:" v-on:submit.prevent="submit">

                    <div v-if="!status.complete">

                        <div class="group">
                          <label for="notPurchasedReason">Why haven’t you purchased or tried this CPAP machine?</label>
                          <select class="validation selectOptGroup"
                                  id="notPurchasedReason"
                                  v-bind:class="{ '-invalid': validation.notPurchasedReason }"
                                  v-model="fields.notPurchasedReason"
                                  @change="updateView">
                            <option selected disabled value="">Select from the following options...</option>

                            <option data-nextstep="[1]" value="I use a different CPAP machine">I use a different CPAP machine</option>
                            <option data-nextstep="[1]" value="I'd like to try it but would need to switch from another CPAP machine">I'd like to try it but would need to switch from another CPAP machine</option>
                            <option value="I have not been diagnosed with sleep apnea">I have not been diagnosed with sleep apnea </option>
                            <option value="I have a prescription for CPAP equipment, but haven’t started therapy">I have a prescription for CPAP equipment, but haven’t started therapy</option>                            
                            <option value="My insurance won't cover a new CPAP machine">My insurance won't cover a new CPAP machine</option>
                            <option data-nextstep="[2]" value="I've tried this machine, and did not like it">I've tried this machine, and did not like it</option>
                            <option value="Haven't selected a CPAP machine; still deciding">Haven't selected a CPAP machine; still deciding</option>
                            <option data-nextstep="[3]" value="Other">Other</option>
                          </select>
                          <div class="error-message" v-for="message in validation.notPurchasedReason">{{ message }}</div>
                        </div>

                        <div v-show="status.step.indexOf(1) != -1" class="group">
                           <label for="otherDeviceBrand">What machine brand are you currently using?</label>
                           <select class="validation selectOptGroup"
                                     v-bind:class="{ '-invalid': validation.otherDeviceBrand }"
                                     v-model="fields.otherDeviceBrand"
                                     @change="updateOtherDeviceBrand">
                               <option selected disabled value="">Select from the following options...</option>
                               <option data-nextstep="[1,4]" value="ResMed">ResMed</option>
                               <option data-nextstep="[1,4]" value="Fisher & Paykel">Fisher & Paykel</option>
                               <option data-nextstep="[1,4]" value="Philips Respironics">Philips Respironics</option>
                               <option data-nextstep="[1,4]" value="Other">Other</option>
                           </select>
                           <div class="error-message" v-for="message in validation.otherDeviceBrand">{{ message }}</div>
                        </div>

                        <div v-show="status.step.indexOf(4) != -1 && fields.otherDeviceBrand == 'Other'" class="group">
                           <label for="updateOtherDeviceBrand">Write your current machine model</label>
                           <input type="text" class="validation"
                                  v-bind:class="{ '-invalid': validation.otherDeviceModels }"
                                  v-model="fields.otherDeviceModels">
                           <div class="error-message" v-for="message in validation.otherDeviceModels">{{ message }}</div>
                        </div>


                        <div v-show="status.step.indexOf(4) != -1  && fields.otherDeviceBrand != 'Other'" class="group">
                           <label for="otherDeviceModels">Pick your current machine model</label>
                           <select class="validation selectOptGroup"
                                     v-bind:class="{ '-invalid': validation.otherDeviceModels }"
                                     v-model="fields.otherDeviceModels"
                                     @change="updateView">
                               <option selected disabled value="">Select from the following options...</option>
                               <option data-nextstep="[1,4]"
                                        v-for="element in devices[fields.otherDeviceBrand]"
                                        v-bind:value="element">
                                          {{ element }}
                               </option>
                           </select>
                           <div class="error-message" v-for="message in validation.otherDeviceModels">{{ message }}</div>
                        </div>

                        <div v-show="status.step.indexOf(1) != -1" class="group">
                           <label for="userLength">How long have you been using your machine?</label>
                           <select class="validation selectOptGroup"
                                     v-bind:class="{ '-invalid': validation.userLength }"
                                     v-model="fields.userLength" @change="updateUserLength()">
                                     <option selected disabled value="">Select from the following options...</option>
                                     <option value="Less than a year">Less than a year</option>
                                     <option value="1 – 2 years">1 – 2 years</option>
                                     <option value="3 – 5 years">3 – 4 years</option>
                                     <option value="5+ years">5+ years</option>
                           </select>
                           <div class="error-message" v-for="message in validation.userLength">{{ message }}</div>
                        </div>

                        <div v-show="status.step.indexOf(2) != -1" class="group">
                           <label for="dislikeReason">What didn't you like about this machine?</label>
                           <select class="validation selectOptGroup"
                                     v-bind:class="{ '-invalid': validation.dislikeReason }"
                                     v-model="fields.dislikeReason"
                                     @change="updateView">
                               <option selected disabled value="">Select from the following options...</option>
                               <option data-nextstep="[2]" value="Had trouble tolerating air pressure">Had trouble tolerating air pressure</option>
                               <option data-nextstep="[2]" value="It was too loud">It was too loud</option>
                               <option data-nextstep="[2]" value="Could not adjust settings">Could not adjust settings</option>
                               <option data-nextstep="[2,3]" value="Other">Other</option>
                           </select>
                           <div class="error-message" v-for="message in validation.dislikeReason">{{ message }}</div>
                        </div>

                        <div v-if="status.step.indexOf(3) != -1" class="group">
                           <label for="dislikeReview">Other reason</label>
                           <textarea class="validation"
                                     v-bind:class="{ '-invalid': validation.dislikeReview }"
                                     v-model="fields.dislikeReview"
                                     v-on:keyup="validation.dislikeReview = null"
                                     placeholder="Please provide feedback on this product here (max 280 characters)" maxlength="280"></textarea>
                           <div class="error-message" v-for="message in validation.dislikeReview">{{ message }}</div>
                        </div>

                        <!-- firstname -->
                        <firstname></firstname>

                        <!-- lastname -->
                        <lastname></lastname>

                        <!-- email and phone -->
                       <email></email>

                        <!-- select: country -->
                        <country></country>

                        <!-- checkbox: feedbackConcent -->
                        <feedbackConsent></feedbackConsent>

                        <!-- checkbox: marketing_oncent -->
                        <marketingConsent></marketingConsent>

                        <!-- submit, validation and confirmation -->
                        <submit-confirmation></submit-confirmation>

                    </div>
                </form>
                <thankyou-message v-if="status.complete"></thankyou-message>
            </div>
        </div>
    </div>

</template>

<script>

    import mixin from './mixin.js'

    let fillable = {
        notPurchasedReason: '',
        userLength: '',
        dislikeReason: '',
        dislikeReview: '',
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        feedbackConsent: '',
        marketing_consent: true,
        referrer: window.location.pathname,
        b2c: 'yes',
        b2b: 'no',
        yes_Rating: false,
        no_Rating: true,
        deviceBrand: '',
        otherDeviceBrand: '',
        deviceModel: '',
        otherDeviceModels: '',
        timeOnMachineDatestamp : '',
        marketingConsentDate: (new Date()).toISOString(),
    }

    export default {
        data() {
            return {
                form: {
                    name: '',   // form name
                    origin: ''  // form origin ( page )
                },
                status: {
                    idle: null,
                    step: [],
                    last_step: [],
                    errors: false,
                    complete: false,
                },
                response: {
                    type: '', // validation or confirmation
                    message: '' // response
                },
                holdingValue: {},
                fields: { ...fillable },
                userLengthRequired: false,
                sendTimeOnMachineDatestamp: false,
                validation: {},
                devices: {
                  'ResMed': [
                    'AirCurve 10 ASV',
                    'AirCurve 10 S',
                    'AirCurve 10 ST',
                    'AirCurve 10 ST-A',
                    'AirCurve 10 VAuto',
                    'AirSense 10 AutoSet',
                    'AirSense 10 AutoSet for Her',
                    'AirSense 10 CPAP',
                    'AirSense 10 Elite',
                    'Other'
                  ],
                  'Fisher & Paykel': [
                    'Icon',
                    'Other'
                  ],
                  'Philips Respironics': [
                    'System One',
                    'Dreamstation',
                    'REMstar',
                    'Other'
                  ]
                }
            }
        },
        mixins: [ mixin ],
        methods: {
            updateView(e) {
              this.validation.notPurchasedReason = null
              this.validation.dislikeReason = null
              if (e.target.options[e.target.options.selectedIndex]) {
                  let step = e.target.options[e.target.options.selectedIndex].dataset.nextstep
                  this.status.step = step ? step : [];
              }
            },
            updateOtherDeviceBrand(e){
              this.fields.otherDeviceModels = '';
              this.updateView(e);
            },
            updateUserLength() {

            }
        }
    }
</script>
